import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
function WorldLabels() {
  const $ = _c(4);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("world-info.labels.showroom");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="flex gap-2"><span className="text-primary-500 subheader-3 text-vive-primary-70 bg-vive-primary-20 flex items-center rounded-[3px] px-2 py-1 text-xs">{t0}</span></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export default WorldLabels;